/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Event } from "@app/services/dispatcher/events/event";
import { TenantOrgEnforcementStatusResponse } from "@api/generated/vcdr";

export class OverageEvent extends Event {
    public static ID: string = "OVERAGE_EVENT";

    constructor(public overageStatus: TenantOrgEnforcementStatusResponse) {
        super(OverageEvent.ID);
    }
}
